module.exports = __webpack_public_path__ + "static/media/Other.b659d455.svg";